import React, { useState, useEffect } from "react";
import InputText from "../Components/InputText";
import Button from "../Components/Button";
import { FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import { BRAND } from "../config/brand";

function ContactUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.message.trim() === "") {
      alert("Please enter a message before submitting.");
      return;
    }

    console.log("Submitted Data:", formData);

    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      message: "",
    });

    alert("Form submitted successfully!");
  };

  return (
    <div className="main-contact">
      <div className="contact-text">
        <motion.span
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Contact Us
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          We are here to assist you.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
        >
          Have inquiries about {BRAND.name}? Send a message and the team will
          help with the project, asset backing, wallet flow, or trading details.
        </motion.p>

        <div className="contact-icons">
          <motion.p
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.6 }}
          >
            <FaEnvelope className="c-icon" />
            {BRAND.contactEmail}
          </motion.p>

          <motion.p
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.8 }}
          >
            <FaMapMarkerAlt className="c-icon" />
            Trident Chambers, Wickhams Cay 1, Road Town, Tortola, British Virgin Islands
          </motion.p>
        </div>
      </div>

      {/* Form with onSubmit */}
      <form className="contact-form" onSubmit={handleSubmit}>
        <InputText
          label="First name"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
        />
        <InputText
          label="Last name"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
        />
        <InputText
          label="Email address"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />

        <div className="text-box-section">
          <label htmlFor="message">Message </label>
          <textarea
            id="text-box"
            name="message"
            value={formData.message}
            onChange={handleChange}
          ></textarea>

          <Button text="Submit" className="secondary" type="submit" />
        </div>
      </form>
    </div>
  );
}

export default ContactUs;
